import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OrganizationService } from '../../../services/organization.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../../services/utility.service';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { CandidateService } from '../../../services/candidate.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'modal-confirm-delete-applications',
  template: require('./modal-confirm-delete-applications.component.pug'),
  styles: [require('./modal-confirm-delete-applications.component.css').toString()],
})
export class ModalConfirmDeleteApplicationsComponent {
  // Options to pass to the modal:
  onDelete: (onFailure: onSmartFailure) => void;
  @Output()
  onApplicationsDeleted = new EventEmitter<void>();

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private watchAccount: WatchAccountService,
    private candidateService: CandidateService,
  ) {}

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  delete(_data: any, _onsuccess: onSmartSuccess, onFailure: onSmartFailure) {
    this.onDelete(onFailure);
  }
}
